import { useEffect, useState } from 'react';
import { Box, Typography, Container, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from "react";
import Comp5Sub from "./Comp5Sub";
import Comp6Sub from "./Comp6Sub";
import axios from "axios";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from './api';
import Header from './components/Header';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";

const FormElectricity = ({exhibitorId: propExhibitorId, isModal=false, setFormModalOpen, isCorpModal=false, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const [sameAsExhibitoro5, setSameAsExhibitoro5] = useState("different");
  const [sameAsExhibitoro6, setSameAsExhibitoro6] = useState("different");
  const [sameAsInvoice5, setSameAsInvoice5] = useState("different");
  const [sameAsInvoice6, setSameAsInvoice6] = useState("different");
  const [comp5Data, setComp5Data] = useState({
    user_5_name: "",
    user_5_department: "",
    user_5_phone: "",
    user_5_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    elec_select: false,
    elec_company_name: "",
    elec_address: "",
    elec_zip: "",
    elec_user_name: "",
    elec_tel: "",
    elec_fax: "",
    quantity_100v: false,
    quantity_200v: false,
    quantity_all: 0,
    alfa_text: "",
    details_100: [],
    details_200: []
  });

  const [checked, setChecked] = useState({
      v100: false,
      v200: false,
  });

  const [detailErrors, setDetailErrors] = useState({
    details_100: [],
    details_200: [],
  });

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

  const [comp6Data, setComp6Data] = useState({
    user_6_name: "",
    user_6_department: "",
    user_6_phone: "",
    user_6_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    elec_total: 0,
    alfa_text: "",
    details: [
      {
        elec_item_id: null,
        number: 0,
      },
    ],
  });
  const [elecItems, setElecItems] = useState([]);

  const [corrections, setCorrections] = useState({
        user_5_info: false,
        invoice_5_info: false,
        user_6_info: false,
        invoice_6_info: false,
  });

  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

   const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

  useEffect(() => {
    const init = async () => {
      // 1. propExhibitorId 優先
      if ((isModal || isCorpModal) && propExhibitorId) {
        setExhibitorId(propExhibitorId);
        return;
      }

      // 2. localStorage 優先
      const userData = localStorage.getItem("user");
      if (userData) {
        const parsedUser = JSON.parse(userData);
        if (parsedUser?.exhibitor_id) {
          setExhibitorId(parsedUser.exhibitor_id);
          return;
        }
      }

      // 3. localStorage ない場合 → APIから再取得
      try {
        const res = await api.get("/api/auth/me"); // ←要: サーバー側で実装
        if (res.data?.exhibitor_id) {
          setExhibitorId(res.data.exhibitor_id);
          localStorage.setItem("user", JSON.stringify(res.data));
        } else {
          console.warn("exhibitor_id が取得できません");
        }
      } catch (err) {
        console.error("ユーザー再取得エラー:", err);
      }
    };

    init();
  }, [location, isModal, isCorpModal, propExhibitorId]);

  const [notApply5, setNotApply5] = useState(false);
  const [notApply6, setNotApply6] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [isHovered, setIsHovered] = useState(false);

  const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
      // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      // { label: '出展者証について', path: '/出展者証について.pdf' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

  const renderMenuItems = () => (
    <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
        <div className="submenu">
            {pdfItems.map((item, index) => (
            <a key={index} href={item.path} download className="submenu-item">
                {item.label}
            </a>
            ))}
        </div>
        )}
    </div>
  );

  useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items");
                setElecItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

  const [noticeModalOpen, setNoticeModalOpen] = useState(false);
  const [ submitErrors5, setSubmitErrors5] = useState({});
  const [ submitErrors6, setSubmitErrors6] = useState({});
  

  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        console.error("exhibitorId が不正やで:", exhibitorId);
        alert("exhibitorId が不正です");
        return;
      }

      // === Comp5Sub バリデーション ===
      const submitErrors5 = {};
      if (!notApply5) {
        if (!comp5Data.user_5_name?.trim()) submitErrors5.user_5_name = "入力してください";
        if (!comp5Data.user_5_department?.trim()) submitErrors5.user_5_department = "入力してください";
        if (!comp5Data.user_5_phone?.trim()) submitErrors5.user_5_phone = "入力してください";
        if (!comp5Data.user_5_tel?.trim()) submitErrors5.user_5_tel = "入力してください";
        if (!comp5Data.invoice_company_name?.trim()) submitErrors5.invoice_company_name = "入力してください";
        if (!comp5Data.invoice_user_name?.trim()) submitErrors5.invoice_user_name = "入力してください";
        if (!comp5Data.invoice_email?.trim()) submitErrors5.invoice_email = "入力してください";
        if (!comp5Data.invoice_address?.trim()) submitErrors5.invoice_address = "入力してください";
        if (!comp5Data.invoice_zip?.trim()) submitErrors5.invoice_zip = "入力してください";
        if (!comp5Data.invoice_tel?.trim()) submitErrors5.invoice_tel = "入力してください";

        // 電気工事業者情報
        if (!comp5Data.elec_select) {
          const requiredFields = [
            "elec_company_name",
            "elec_zip",
            "elec_address",
            "elec_user_name",
            "elec_tel",
            "elec_fax"
          ];
          requiredFields.forEach((field) => {
            if (!comp5Data[field] || comp5Data[field].trim() === "") {
              submitErrors5[field] = "必須入力です";
            }
          });
        }

        // 必要電気容量
        if (!checked?.v100 && !checked?.v200) {
          submitErrors5.elec_check = "100Vか200Vのいずれかを選択してください";
        }

        // 100V詳細
        if (checked?.v100) {
          const hasDetailQuantity = comp5Data.details_100.some(d => d.quantity_100 > 0);
          if (!hasDetailQuantity) {
            submitErrors5.details_100 = "100Vの容量または詳細を入力してください";
          }
          comp5Data.details_100.forEach((d, i) => {
            if (d.quantity_100 > 0 && !d.number_100) {
              submitErrors5[`details_100_${i}_number`] = "数量を入力してください";
            }
          });
        }

        // 200V詳細
        if (checked?.v200) {
          const hasDetailQuantity = comp5Data.details_200.some(d => d.quantity_200 > 0);
          if (!hasDetailQuantity) {
            submitErrors5.details_200 = "200Vの容量または詳細を入力してください";
          }
          comp5Data.details_200.forEach((d, i) => {
            if (d.quantity_200 > 0 && !d.number_200) {
              submitErrors5[`details_200_${i}_number`] = "数量を入力してください";
            }
          });
        }
      }

      // === Comp6Sub バリデーション ===
      const submitErrors6 = {};
      if (!notApply6) {
        const hasAtLeastOne = comp6Data.details.some(d => Number(d.number) >= 1);
        if (!comp6Data.user_6_name?.trim()) submitErrors6.user_6_name = "入力してください";
        if (!comp6Data.user_6_department?.trim()) submitErrors6.user_6_department = "入力してください";
        if (!comp6Data.user_6_phone?.trim()) submitErrors6.user_6_phone = "入力してください";
        if (!comp6Data.user_6_tel?.trim()) submitErrors6.user_6_tel = "入力してください";
        if (!comp6Data.invoice_company_name?.trim()) submitErrors6.invoice_company_name = "入力してください";
        if (!comp6Data.invoice_user_name?.trim()) submitErrors6.invoice_user_name = "入力してください";
        if (!comp6Data.invoice_email?.trim()) submitErrors6.invoice_email = "入力してください";
        if (!comp6Data.invoice_address?.trim()) submitErrors6.invoice_address = "入力してください";
        if (!comp6Data.invoice_zip?.trim()) submitErrors6.invoice_zip = "入力してください";
        if (!comp6Data.invoice_tel?.trim()) submitErrors6.invoice_tel = "入力してください";
        if (!hasAtLeastOne) submitErrors6.details = "いずれかの備品の数量を1以上にしてください";
      }

      // === エラーがあれば表示して中止 ===
      if (Object.keys(submitErrors5).length > 0 || Object.keys(submitErrors6).length > 0) {
        setSubmitErrors5(submitErrors5);
        setSubmitErrors6(submitErrors6);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const fieldDisplayNames = {
          user_5_name: "担当者名",
          user_5_department: "担当部署",
          user_5_phone: "担当者携帯",
          user_5_tel: "担当者電話",
          user_6_name: "担当者名",
          user_6_department: "担当部署",
          user_6_phone: "担当者携帯",
          user_6_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
          elec_select: "電気工事委託 有無選択",
          elec_company_name: "電気工事委託 会社名",
          elec_zip: "電気工事委託 郵便番号",
          elec_address: "電気工事委託 住所",
          elec_user_name: "電気工事委託 担当者名",
          elec_tel: "電気工事委託 電話番号",
          elec_fax: "電気工事委託 FAX番号",
          elec_check: "必要電気容量",
          quantity_100v: "100V 終夜送電",
          quantity_200v: "200V 終夜送電",
          details_100: "100V 機器詳細",
          details_200: "200V 機器詳細",
          details_100_name: "100V 機器名",
          details_100_quantity: "100V 容量",
          details_100_number: "100V 台数",
          details_200_name: "200V 機器名",
          details_200_quantity: "200V 容量",
          details_200_number: "200V 台数",
        };

        const allErrors = { ...submitErrors5, ...submitErrors6 };
        const errorMessages = Object.entries(allErrors)
          .map(([key, msg]) => {
            const baseKey = key.replace(/_\d+_.*/, "");
            return `・${fieldDisplayNames[key] || fieldDisplayNames[baseKey] || key}：${msg}`;
          })
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      // === not apply データ ===
      const noAp5Data = {
        user_5_name: "",
        user_5_department: "",
        user_5_phone: "",
        user_5_tel: "",
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
        invoice_fax: "",
        elec_select: null,
        elec_company_name: null,
        elec_address: null,
        elec_zip: null,
        elec_user_name: null,
        elec_tel: null,
        elec_fax: null,
        quantity_100v: null,
        quantity_200v: null,
        quantity_all: null,
        alfa_text: null,
        details_100: [],
        details_200: []
      };

      const noAp6Data = {
        user_6_name: "",
        user_6_department: "",
        user_6_phone: "",
        user_6_tel: "",
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
        invoice_fax: "",
        elec_total: null,
        alfa_text: null,
        details: []
      };

      // === サニタイズ関数 ===
      const sanitizeDetails = (details, type) => {
        if (!Array.isArray(details)) return [];
        return details
          .filter(d => {
            if (type === "100") return d.quantity_100 > 0 && d.number_100 > 0;
            if (type === "200") return d.quantity_200 > 0 && d.number_200 > 0;
            return d.elec_item_id && d.number > 0; // comp6
          })
          .map(d => ({ ...d }));
      };

      const sanitizeComp5Data = (data) => {
        let newData = { ...data };

        // elec_select サニタイズ
        if (newData.elec_select === null) {
          if (notApply5) {
            newData.elec_select = null; // そのまま
          } else if (!newData.elec_company_name || newData.elec_company_name.trim() === "") {
            newData.elec_select = true;
          } else {
            newData.elec_select = false;
          }
        }

        return newData;
      };

      // === データ整形 ===
      const sanitizedComp5 = sanitizeComp5Data(comp5Data);
      sanitizedComp5.details_100 = sanitizeDetails(sanitizedComp5.details_100, "100");
      sanitizedComp5.details_200 = sanitizeDetails(sanitizedComp5.details_200, "200");

      const sanitizedComp6 = {
        ...comp6Data,
        details: sanitizeDetails(comp6Data.details, "comp6")
      };

      const payload = {
        exhibitor_id: exhibitorId,
        notApply5,
        notApply6,
        o5: notApply5 ? noAp5Data : sanitizedComp5,
        o6: notApply6 ? noAp6Data : sanitizedComp6,
      };

      console.log(payload);

      const res = await api.post("/api/elec-submit", payload);
      if (res.status === 200) {
        setNoticeModalOpen(true);
        alert("保存成功");
      } else {
        alert("保存失敗");
      }
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };

  const handleCloseNotice = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setNoticeModalOpen(false);
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else {
        if (user?.user_id === 0) {
          navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }
    }, 1000);
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="しんきんビジネスマッチング　ビジネスフェア2026 電気使用申請"
          companyName={mypageData?.company_name}
        />
      )}
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <Container sx={{ width: '22%', mt: 4 }}>
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed', width: '14%' }}>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width:'80%', mt:4, pb:'30px'}}>
            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', margin: 'auto'}}>電気(電力)使用申込</Typography>
            <Container sx={{width: '95%', margin: 'auto', border: '1px solid #000', borderRadius: '12px'}}>
                <Comp5Sub formData={comp5Data} checked={checked} setChecked={setChecked} submitErrors={submitErrors5} setSubmitErrors={setSubmitErrors5} exhibitorId={exhibitorId} setFormData={setComp5Data} mypageData={mypageData} sameAsExhibitor={sameAsExhibitoro5} setSameAsExhibitor={setSameAsExhibitoro5} sameAsInvoice={sameAsInvoice5} setSameAsInvoice={setSameAsInvoice5} setNotApply={setNotApply5} notApply={notApply5} detailErrors={detailErrors} setDetailErrors={setDetailErrors} />
            </Container>

            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', mx: 'auto', my: 4}}>電気備品レンタル申込</Typography>
            <Container sx={{width: '95%', margin: 'auto', border: '1px solid #000', borderRadius: '12px'}}>
                <Comp6Sub formData={comp6Data} submitErrors={submitErrors6} exhibitorId={exhibitorId} setFormData={setComp6Data} mypageData={mypageData} sameAsExhibitor={sameAsExhibitoro6} setSameAsExhibitor={setSameAsExhibitoro6} sameAsInvoice={sameAsInvoice6} setSameAsInvoice={setSameAsInvoice6} setNotApply={setNotApply6} notApply={notApply6} elecItems={elecItems} />
            </Container>
            <div style={{padding: '15px'}}></div>
            <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
              <Typography>
                【上記入力内容についてのお問い合わせ先】<br />
                (株) 小野電気<br />
                担当：山田、山口、鬼頭<br />
                TEL:0568-29-3031<br />
                入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
                ※お急ぎの場合はお電話にてお問い合わせください。
              </Typography>
            </Box>
            {!isCorpModal &&(
            <Container sx={{textAlign: 'center'}}>
                <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                    提出する
                </Button>
            </Container>
            )}
        </Container>
      </Container>
      <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
        <DialogTitle>注意事項</DialogTitle>
        <DialogContent>
          <p>
            電気・電力申込を申請する場合は、電気引き出し位置及び備品設置位置を「ブース平面図」よりご提出ください。<br />
            ※電気取り出し位置について指示がない場合は出展の手引きp.23の内容に沿って設置させていただきます。
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNotice} color="primary">
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
      {!isCorpModal &&(
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button
          variant="contained"
          onClick={handleCorrection}
          sx={{
            backgroundColor: "red",
            color: "white",
            "&:hover": {
              backgroundColor: "darkred",
            },
          }}
        >
          再提出
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          完了
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default FormElectricity;
